export default __webpack_public_path__ + "static/media/CoinHub.a8cb19a1.png";